import { getItem } from '@ms/yammer-libs-local-storage';
import { AppLayoutBreakpoint } from '@ms/yammer-web-core-ui/dist/util/responsiveness';

export const minWidth = 260;
export const maxWidth = 400;
export const reservedViewportWidth: number = AppLayoutBreakpoint.Width568;
export const persistedWidthKey = 'engage.leftNav.width';

export const clamp = (value: number, min: number, max: number): number => Math.max(min, Math.min(max, value));

// The largest width the nav may occupy at the current viewport: the configured max, shrunk so the
// main content always keeps `reservedViewportWidth` of room. Shared by the resize hook and the
// Suspense fallback so both clamp against the same responsive ceiling.
export const computeResponsiveMaxWidth = (min: number, max: number, reserved: number): number =>
  Math.max(min, Math.min(max, window.innerWidth - reserved));

// Clamps a starting width to the responsive bounds. Shared by the resize hook's initial state and
// the Suspense fallback so a cold-load fallback render matches the width the mounted nav settles on,
// avoiding a layout shift.
export const computeInitialWidth = (
  initialWidth: number | null,
  min: number,
  max: number,
  reserved: number
): number | null =>
  initialWidth == null ? null : clamp(initialWidth, min, computeResponsiveMaxWidth(min, max, reserved));

export const readPersistedWidth = (): number | null => {
  const persisted = getItem<number>(persistedWidthKey);
  if (typeof persisted !== 'number' || Number.isNaN(persisted)) {
    return null;
  }

  return clamp(persisted, minWidth, maxWidth);
};

export const readPersistedInitialWidth = (): number | null =>
  computeInitialWidth(readPersistedWidth(), minWidth, maxWidth, reservedViewportWidth);
